module.exports = __webpack_public_path__ + "static/media/wireframe.sketches.637be5d7.jpg";